module.exports = __webpack_public_path__ + "media/components/shared/images/Clear-c0708ad91d8e6c3282d5ed215eff8d4c.svg";